'use client';

import HelpArticleCard from '@/components/help/HelpArticleCard';
import { renderMarkdown } from '@/lib/chat/render-markdown';

/**
 * Mucka message content with inline [[help:slug]] marker support.
 * Splits the raw text on help markers, renders each text segment as
 * markdown HTML and intersperses HelpArticleCard React components at
 * the marker positions. Falls back to a plain markdown render when no
 * markers are present (the common case).
 */
export default function MuckaReplyText({
  text,
  onOpenHelp,
}: {
  text: string;
  onOpenHelp: (slug: string) => void;
}) {
  const regex = /\[\[help:([\w-]+)\]\]/g;
  if (!regex.test(text)) {
    return <div dangerouslySetInnerHTML={{ __html: renderMarkdown(text) }} />;
  }
  regex.lastIndex = 0;
  const parts: Array<{ kind: 'text'; value: string } | { kind: 'help'; slug: string }> = [];
  let last = 0;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > last) {
      parts.push({ kind: 'text', value: text.slice(last, match.index) });
    }
    parts.push({ kind: 'help', slug: match[1] });
    last = regex.lastIndex;
  }
  if (last < text.length) {
    parts.push({ kind: 'text', value: text.slice(last) });
  }
  return (
    <>
      {parts.map((part, i) =>
        part.kind === 'text' ? (
          <div
            key={i}
            dangerouslySetInnerHTML={{ __html: renderMarkdown(part.value) }}
          />
        ) : (
          <HelpArticleCard key={i} slug={part.slug} onOpen={onOpenHelp} />
        ),
      )}
    </>
  );
}